export const MAX_HEIGHT = 400; // maximum height of the dropdown menu
export const ITEM_HEIGHT = 34; // Estimated height of a single menu item for virtualization
export const MIN_ITEMS_FOR_VIRTUALIZATION = 200; // Only virtualize if we have more than this many items
export const SEARCH_BAR_HEIGHT = 44;
export const DROPDOWN_MENU_PORTAL_ID = "dropdown-menu-root";
